
define("rv!templates/partials/ManualBookingForm",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:7,
          e:"form",
          v:{ submit:"onManualBook" },
          a:{ "class":"well",
            id:"manualBookingForm",
            style:"text-align: right;" },
          f:[ { t:7,
              e:"div",
              a:{ style:"text-align: left;" },
              f:[ { t:7,
                  e:"h2",
                  f:[ "Manual Book" ] },
                " ",
                { t:7,
                  e:"hr",
                  a:{ style:"margin-top: 5px; margin-bottom: 10px;" } },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"row" },
                  f:[ { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ "Confirmation Number* ",
                        { t:7,
                          e:"input",
                          a:{ type:"text",
                            "class":"input-string",
                            value:[ { t:2,
                                r:"data.planningData.ManualBooking.ConfirmationNumber" } ] },
                          v:{ change:"updateManualBooking" } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ "Room Name* ",
                        { t:7,
                          e:"input",
                          a:{ type:"text",
                            "class":"input-string",
                            value:[ { t:2,
                                r:"data.planningData.DestinationInfo.RoomName" } ] },
                          v:{ change:"updateManualBooking" } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ "Room Description ",
                        { t:7,
                          e:"textarea",
                          a:{ "class":"input-string",
                            value:[ { t:2,
                                r:"data.planningData.ManualBooking.RoomDescription" } ] } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ "Corporate Discount Code* ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"text",
                            "class":"input-string",
                            value:[ { t:2,
                                r:"data.planningData.DestinationInfo.RoomCorporateDisc" } ],
                            style:"width: 50px;" },
                          v:{ change:"updateManualBooking" } },
                        " ",
                        { t:7,
                          e:"span",
                          a:{ "class":"sideNote" },
                          f:[ "(probably either ADN or OGADN1)" ] } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ { t:4,
                          f:[ "Room Rate* ",
                            { t:7,
                              e:"span",
                              a:{ "class":"sideNote" },
                              f:[ "(for all nights)" ] } ],
                          n:50,
                          x:{ r:[ "provider.Adestinn",
                              "data.ProviderCode" ],
                            s:"_0==_1" } },
                        { t:4,
                          n:51,
                          f:[ { t:4,
                              n:50,
                              x:{ r:[ "provider.Hotelbeds",
                                  "data.ProviderCode" ],
                                s:"_0==_1" },
                              f:[ "Selling Room Rate*",
                                { t:7,
                                  e:"span",
                                  a:{ "class":"sideNote" },
                                  f:[ "(for all nights, member pays)" ] } ] } ],
                          x:{ r:[ "provider.Adestinn",
                              "data.ProviderCode" ],
                            s:"_0==_1" } },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"text" },
                          o:{ n:"calculator",
                            a:"data.planningData.DestinationInfo.Rate.RoomRateTotal" },
                          v:{ blur:"updateManualBooking" } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ { t:4,
                          f:[ "Room Tax*" ],
                          n:50,
                          x:{ r:[ "provider.Adestinn",
                              "data.ProviderCode" ],
                            s:"_0==_1" } },
                        { t:4,
                          n:51,
                          f:[ { t:4,
                              n:50,
                              x:{ r:[ "provider.Hotelbeds",
                                  "data.ProviderCode" ],
                                s:"_0==_1" },
                              f:[ "Selling Room Tax* ",
                                { t:7,
                                  e:"span",
                                  a:{ "class":"sideNote" },
                                  f:[ "(included tax, member pays)" ] } ] } ],
                          x:{ r:[ "provider.Adestinn",
                              "data.ProviderCode" ],
                            s:"_0==_1" } },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ type:"text" },
                          o:{ n:"calculator",
                            a:"data.planningData.DestinationInfo.Rate.HotelTaxFeeTotal" },
                          v:{ blur:"updateManualBooking" } } ] },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"span4" },
                          f:[ "Room Type Code* ",
                            { t:7,
                              e:"span",
                              a:{ "class":"sideNote" },
                              f:[ "(e.g. \"1BR\")" ] },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                "class":"input-string",
                                value:[ { t:2,
                                    r:"data.planningData.DestinationInfo.RoomTypeCode" } ] },
                              v:{ change:"updateManualBooking" } } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ "class":"span4" },
                          f:[ "Rate Plan Code* ",
                            { t:7,
                              e:"span",
                              a:{ "class":"sideNote" },
                              f:[ "(aka \"RateCode\", probably either ADN or OGADN1)" ] },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                "class":"input-string",
                                value:[ { t:2,
                                    r:"data.planningData.DestinationInfo.Rate.RatePlanCode" } ] } },
                            " ",
                            { t:7,
                              e:"br" } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ "class":"span4" },
                          f:[ "Room Fee* ",
                            { t:7,
                              e:"input",
                              a:{ type:"text" },
                              o:{ n:"calculator",
                                a:"data.planningData.DestinationInfo.Rate.HotelFeeTotal" },
                              v:{ blur:"updateManualBooking" } } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ "class":"span4" },
                          f:[ "Recovery Fee* ",
                            { t:7,
                              e:"input",
                              a:{ type:"text" },
                              o:{ n:"calculator",
                                a:"data.planningData.DestinationInfo.Rate.RecoveryFee" },
                              v:{ blur:"updateManualBooking" } } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ "class":"span4" },
                          f:[ "Policies* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"textarea",
                              a:{ "class":"input-string",
                                value:[ { t:2,
                                    r:"data.planningData.ManualBooking.CancellationPolicy" } ] },
                              v:{ change:"updateManualBooking" } } ] } ],
                      n:50,
                      x:{ r:[ "provider.Adestinn",
                          "data.ProviderCode" ],
                        s:"_0==_1" } },
                    { t:4,
                      n:51,
                      f:[ { t:4,
                          n:50,
                          x:{ r:[ "provider.Hotelbeds",
                              "data.ProviderCode" ],
                            s:"_0==_1" },
                          f:[ { t:7,
                              e:"div",
                              a:{ "class":"span4" },
                              f:[ "Excluded Tax ",
                                { t:7,
                                  e:"span",
                                  a:{ "class":"sideNote" },
                                  f:[ "(charge paid by member at check-in (taxes, fees, etc.))" ] },
                                " ",
                                { t:7,
                                  e:"input",
                                  a:{ type:"text",
                                    "class":"input-string" },
                                  o:{ n:"calculator",
                                    a:"data.planningData.DestinationInfo.Rate.HotelExcludedTax" },
                                  v:{ blur:"updateManualBooking" } } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ "class":"span4" },
                              f:[ "Purchase Room Rate* ",
                                { t:7,
                                  e:"span",
                                  a:{ "class":"sideNote" },
                                  f:[ "(for all nights, what we pay, net)" ] },
                                " ",
                                { t:7,
                                  e:"input",
                                  a:{ type:"text",
                                    "class":"input-string" },
                                  o:{ n:"calculator",
                                    a:"data.planningData.DestinationInfo.Rate.LoyaltyRoomRateTotal" },
                                  v:{ blur:"updateManualBooking" } } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ "class":"span4" },
                              f:[ "Purchase Room Tax* ",
                                { t:7,
                                  e:"span",
                                  a:{ "class":"sideNote" },
                                  f:[ "(included tax, what we pay, net)" ] },
                                " ",
                                { t:7,
                                  e:"input",
                                  a:{ type:"text",
                                    "class":"input-string" },
                                  o:{ n:"calculator",
                                    a:"data.planningData.DestinationInfo.Rate.LoyaltyHotelTaxFeeTotal" },
                                  v:{ blur:"updateManualBooking" } } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ "class":"span4" },
                              f:[ "Room Code* ",
                                { t:7,
                                  e:"input",
                                  a:{ type:"text",
                                    "class":"input-string",
                                    value:[ { t:2,
                                        r:"data.planningData.DestinationInfo.RoomCode" } ] },
                                  v:{ change:"updateManualBooking" } } ] },
                            " " ] } ],
                      x:{ r:[ "provider.Adestinn",
                          "data.ProviderCode" ],
                        s:"_0==_1" } },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"span4" },
                      f:[ "Comments for Manual Booking* ",
                        { t:7,
                          e:"textarea",
                          a:{ "class":"input-string",
                            value:[ { t:2,
                                r:"data.planningData.ManualBooking.Comments" } ] },
                          v:{ change:"updateManualBooking" } } ] },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"span4",
                            style:"margin: 30px 15px" },
                          f:[ { t:7,
                              e:"a",
                              a:{ "class":"btn btn-primary",
                                id:"addCancellationPolicy" },
                              m:[ { t:4,
                                  f:[ "style=\"visibility:hidden;\"" ],
                                  n:50,
                                  x:{ r:[ "data.planningData.DestinationInfo.Rate.CancellationPolicies.length" ],
                                    s:"_0>=5" } } ],
                              v:{ click:"onAddPolicy" },
                              f:[ "Add Policy" ] },
                            " ",
                            { t:4,
                              f:[ { t:7,
                                  e:"a",
                                  a:{ "class":"btn btn-secondary",
                                    id:"removeCancellationPolicy" },
                                  v:{ click:"onRemovePolicy" },
                                  f:[ "Remove Policy" ] } ],
                              n:50,
                              r:"data.planningData.DestinationInfo.Rate.CancellationPolicies.length" } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ id:"hotelbedsCancellationInputs" },
                          f:[  ] } ],
                      n:50,
                      x:{ r:[ "provider.Hotelbeds",
                          "data.ProviderCode" ],
                        s:"_0==_1" } } ] } ] },
            " ",
            { t:7,
              e:"button",
              a:{ type:"submit",
                "class":"btn btn-primary",
                disabled:[ { t:2,
                    x:{ r:[ "isManualFormValid" ],
                      s:"!_0" } } ] },
              f:[ "Continue" ] } ] },
        " " ],
      n:50,
      r:"isDba" } ] };});
